// extracted by mini-css-extract-plugin
export var compactFilters = "_e1-4";
export var detailImage = "_e1-1";
export var dropdownContainer = "_e1-2";
export var imageContainer = "_e1-0";
export var selectedCard = "_e1-3";